/*eslint-disable no-unused-vars */
/*eslint-disable array-callback-return */
/*eslint-disable eqeqeq */
import React, { useEffect, useState } from 'react';
import { Button, Form, Space, AutoComplete } from 'antd';
import {
  MinusCircleOutlined,
  PlusOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import { SubstractionIconSVG } from '../../../img/NotificationSVG';
import { FormContent } from '../Styles/AddListing.style';
import { useTranslation } from 'react-i18next';
import RoleList from '../../../api/SearchRoles';
import RoleListDependent from '../../../api/SearchRolesDependent';
import APIEndpoints from '../../../api/APIEndpoints';
import HttpErrorHandler from '../../../errorhandling/HttpErrorHandler';
import {
  HttpErrorCodes,
  HttpSuccessCodes,
} from '../../../errorhandling/HttpErrorCodes';
import RetryAPI from '../../../api/RetryAPI';
import ToastMessage from '../../common/ToastMessage';

//Toast
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { axiosInstance } from '../../../../api/axios';

const cacheBuster = (url) => `${url}?cb=${Date.now()}`;
//Permission Groups
const DefaultPermissionGroups = (props) => {
  const [options, setOptions] = useState([]);
  const [data, setData] = useState();
  const [indexFocused, setIndexFocused] = useState(-1);
  const [searchValue, setSearchValue] = useState('');
  const { t } = useTranslation();
  const hasEditPermission = props.hasEditPermission;

  let SearchList;
  let SearchValue;
  let BLOBArray = [];

  const checkDuplicate = (event) => {
    const currentlyUsedList = props.GroupData;
    return currentlyUsedList.indexOf(event);
  };

  //select field handlers
  const onFocus = (index) => {
    commonFilterData();
    setOptions(BLOBArray);
    setIndexFocused(index);
  };

  const onSearch = (event) => {
    SearchList = event;
    setSearchValue(event);
    commonFilterData();
    setOptions(BLOBArray);
  };

  const onBlur = () => {
    setSearchValue('');
    setIndexFocused(-1);
  };

  const commonFilterData = (RoleListData = null) => {
    SearchValue =
      props.userType == 'Member'
        ? RoleList.getRoleListResp()
        : RoleListDependent.getRoleListResp();
    if (!SearchValue) {
      SearchValue = RoleListData;
    }
    SearchValue = SearchValue?.Response.Roles;

    if (SearchList && SearchList?.length > 0) {
      SearchValue = SearchValue?.filter((ele) =>
        ele.RoleName.toLowerCase().startsWith(SearchList.toLowerCase()),
      );
    }

    BLOBArray = [];
    SearchValue &&
      SearchValue.map((key) => {
        if (key.RoleName) {
          BLOBArray.push({
            key: key.RoleName,
            value: key.RoleName,
          });
        }
      });
  };

  useEffect(() => {
    const getRoleList = async () => {
      let RoleListResponse, RoleListDataResp;
      const userType = props.userType == 'Member' ? 'Employee' : 'Dependent';

      if (RoleListResponse == null) {
        RetryAPI.setResponseReceived(false);
        RetryAPI.resetRetryCount();
        while (RetryAPI.performRetry()) {
          try {
            const EncrptedResp = await axiosInstance.get(
              cacheBuster(APIEndpoints.getRoleListResources() + 'pagesize/100'),
            );
            RoleListResponse = EncrptedResp;
            RoleListDataResp = RoleListResponse.data;

            if (
              RoleListResponse.status == HttpSuccessCodes.HTTP_SUCCESS_CODE_200
            ) {
              RoleListDataResp.Response.Roles =
                RoleListDataResp.Response.Roles.filter((roleData) => {
                  if (roleData.UserType === userType) {
                    return roleData;
                  }
                });
              props.userType == 'Member'
                ? RoleList.setRoleListResp(RoleListDataResp)
                : RoleListDependent.setRoleListResp(RoleListDataResp);
              RetryAPI.resetRetryCount();
              RetryAPI.setResponseReceived(true);
              setData(RoleListDataResp);
              commonFilterData(RoleListDataResp);
              setOptions(BLOBArray);
            } else {
              RetryAPI.incrementRetryCount();
              RetryAPI.setResponseReceived(false);
              RetryAPI.setErrorCode(RoleListResponse.status);
            }

            if (RetryAPI.getResponseReceived()) break;
          } catch (error) {
            let errorMessage = '';
            let requestAborted = '';

            if (error) {
              errorMessage = error.toString();
              requestAborted = errorMessage.match(/aborted/i);
              RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
            }
            if (error.response) {
              RetryAPI.setErrorCode(error.response.status);
            }
            RetryAPI.incrementRetryCount();
            RetryAPI.setResponseReceived(false);
          }
        }

        if (RetryAPI.retryFailed()) {
          const errorCode = RetryAPI.getErrorCode();
          HttpErrorHandler.DisplayServerErrorMessage(errorCode, '');
          //Handle Exception
          HttpErrorHandler.ProcessedException(
            errorCode,
            'We are unable to render your Role List now.',
          );
          return;
        }
      }
    };
    getRoleList();
  }, []);

  const Add = (index) => {
    props.onGroupDataChange('', index);
  };

  const onSelect = (event, index) => {
    setSearchValue('');
    setIndexFocused(-1);

    const dupeIndex = checkDuplicate(event, index);

    if (dupeIndex === -1) {
      const BLOBOid = options.find((opt) => opt.value === event);
      if (BLOBOid) {
        props.onGroupDataChange(BLOBOid.key, index);
      }
    } else if (dupeIndex === index) {
      return;
    } else {
      toast.error(<ToastMessage type="error" subTitle=" Duplicate Group" />);
      props.onGroupDataChange('REMOVE', index);
    }
  };

  return (
    <Form>
      <FormContent>
        <Form.List name="roleNames">
          {() => {
            const itemInputs = props.GroupData.map((item) => {
              return {
                value: item,
                key: item,
              };
            });
            return (
              <div>
                {itemInputs.map((item, index) => (
                  <Space
                    key={item.key}
                    style={{ display: 'flex', marginBottom: 8 }}
                    align="start"
                  >
                    <Form.Item
                      {...item}
                      label={'Permission'}
                      required={false}
                      key={item.key}
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'start',
                      }}
                    >
                      <AutoComplete
                        options={options}
                        style={{ width: 290 }}
                        value={
                          indexFocused === index && searchValue
                            ? searchValue
                            : item.value
                        }
                        onSelect={(event) => onSelect(event, index)}
                        onSearch={onSearch}
                        onFocus={() => onFocus(index)}
                        placeholder="Search Group"
                        className="addLOC"
                        onBlur={onBlur}
                      />

                      {/*No Options Tooltip */}
                      {indexFocused === index &&
                        options?.length === 0 &&
                        data && (
                          <div
                            style={{
                              position: 'absolute',
                              marginTop: '-16px',
                              alignContent: 'center',
                              width: '250px',
                              height: '35px',
                              justifyContent: 'center',
                              backgroundColor: '#0066CC',
                              color: 'white',
                              paddingLeft: '12px',
                              paddingTop: '6px',
                              borderRadius: '3px',
                            }}
                          >
                            {t('admin.permission_group.options')}
                          </div>
                        )}

                      {itemInputs[index].value ? (
                        <Button
                          onClick={() => {
                            props.onGroupDataChange('REMOVE', index);
                          }}
                          style={{
                            Color: 'red',
                            marginLeft: '1rem',
                            paddingLeft: '1rem',
                            paddingRight: '1rem',
                          }}
                          disabled={!hasEditPermission}
                          className="minus-blob"
                        >
                          <SubstractionIconSVG />
                          {t('admin.permission_group.remove_group_2')}
                        </Button>
                      ) : (
                        <SubstractionIconSVG
                          onClick={() => {
                            hasEditPermission &&
                              props.onGroupDataChange('REMOVE', index);
                          }}
                          style={{
                            marginLeft: '1rem',
                          }}
                        />
                      )}
                    </Form.Item>
                  </Space>
                ))}
                <Form.Item>
                  {itemInputs?.length === 0 ? (
                    <Button
                      type="dashed"
                      onClick={() => Add(itemInputs?.length)}
                      style={{
                        width: 290,
                        marginBottom: '10px',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <PlusOutlined />
                      {t('admin.permission_group.module_2')}
                    </Button>
                  ) : null}
                </Form.Item>
              </div>
            );
          }}
        </Form.List>
      </FormContent>
    </Form>
  );
};

export default DefaultPermissionGroups;
